import { ActionBase } from '../../../core/store/action/ActionBase';

export const REPOROCESS_JOB_SUBMISSION_SUCCESS = '[Submission] Reprocess Job Submission Success';

export class ReprocessJobSubmissionSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REPOROCESS_JOB_SUBMISSION_SUCCESS;

  constructor(public payload: { jobKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/ReprocessJobSubmissionSuccessAction.ts